import script from "./TermsAndConditionsPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsAndConditionsPopup.vue?vue&type=script&lang=ts&setup=true"

import "./TermsAndConditionsPopup.vue?vue&type=style&index=0&id=008846f0&lang=scss"

const __exports__ = script;

export default __exports__